// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/live-interest-rates/live-interest-rates.component.scss
// module id = 987
// module chunks = 0